'use strict';

function UrlHelpers() { }

UrlHelpers.OpenBrowserTab = function (url, openInNewTab, noNavigationID, overrideHistoryUrl) {
    // If openInNewTab is not set, read value from user settings
    if (openInNewTab === undefined && $.agito.openInNewTab) {
        openInNewTab = $.agito.openInNewTab;
    }
    var nav = $('li.globalnavigation-collapse-lg[data-globalnavigation-level="2"]');
    //in case we start from global navigation level 2 
    if (nav.length > 0 && !noNavigationID) {
        var navigationId = nav.attr('data-navigation-id');
        url = UrlHelpers.AddQueryParam(url, 'navigationId', navigationId);
    }
    if (!openInNewTab) {
        UrlHelpers.PushHistory(overrideHistoryUrl || window.location.href);

        window.agTestContext = window.agTestContext || {};
        window.agTestContext.loading = true;

        window.location = url;
    } else {
        let wind = window.open(url, '_blank'); 

        if(wind != null)
            wind.focus();
    }

};

UrlHelpers.GetHistory = function () {
    var historyStorage = JSON.parse(window.sessionStorage.getItem("history"));
    if (!historyStorage)
        historyStorage = [];

    return historyStorage;
};

UrlHelpers.PushHistory = function (url) {
    var historyStorage = UrlHelpers.GetHistory();

    historyStorage.push({
        url: url
    });
    window.sessionStorage.setItem('history', JSON.stringify(historyStorage));
};

UrlHelpers.PopHistory = function() {

    if (!UrlHelpers.CountHistory()) {
        return { url: $.agito.baseUrl };
    }

    var historyStorage = UrlHelpers.GetHistory();

    var history = historyStorage.pop();
    window.sessionStorage.setItem('history', JSON.stringify(historyStorage));

    return history;
};

UrlHelpers.CountHistory = function () {
    var historyStorage = UrlHelpers.GetHistory();

    return historyStorage.length;
};

UrlHelpers.OpenBrowserTabWithName = function (url, name) {
    window.open(url, name);
};

UrlHelpers.ParseQueryString = function (url) {

    var urlParams = {};

    url.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function ($0, $1, $2, $3) {
            urlParams[$1] = $3;
        }
    );

    return urlParams;
};

// Get path of URL (without query).
UrlHelpers.GetPath = function (url) {
    var splitIndex = url.indexOf('?');
    if (splitIndex === -1)
        return url;

    return url.slice(0, splitIndex);
};

// Get query object.
UrlHelpers.GetQuery = function (url) {
    var queryParams = {};

    var hash;
    var hashes = url.replace(UrlHelpers.GetPath(url), '').replace('?', '').split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        queryParams[hash[0]] = decodeURIComponent((hash[1] + '').replace(/\+/g, '%20'));
    }

    return queryParams;
};

// Add query parameter to URL and return new URL string.
UrlHelpers.AddQueryParam = function (url, key, value) {
    var added = false;
    var hashes = url.replace(UrlHelpers.GetPath(url), '').replace('?', '').split('&');
    for (var i = 0; i < hashes.length; i++) {
        var hash = hashes[i].split('=');
        if (hash[0] === key) {
            hashes[i] = key + '=' + encodeURIComponent(value);
            added = true;
        }
    }

    if(!added)
        hashes.push(key + '=' + encodeURIComponent(value));

    var returnValue = UrlHelpers.GetPath(url);
    if(hashes.length > 0)
        returnValue += '?' + hashes.join('&');

    return returnValue;
};

UrlHelpers.GetQueryParam = function (url, key) {
    return AjaxHelpers.GetUrlParam(key, url);
};

UrlHelpers.RemoveUrlParameter = function (url, parameter) {

    var urlparts = url.split('?');

    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
};
